/* eslint-disable react/destructuring-assignment */
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';

import { TimePicker, ITimePickerProps } from './TimePicker';

type Value = ITimePickerProps['value'];
type ITimePickerFieldProps = ITimePickerProps & FieldProps<Value, FieldRenderProps<Value>>;

export const TimePickerField = (props: ITimePickerFieldProps) => (
  <Field {...props}>
    {({ input, meta }) => {
      const error = typeof props.error === 'boolean' ? props.error && meta.error : meta.touched && meta.error;

      function handleChange(date: string | Date) {
        const { onChange } = props;

        input.onChange(date);
        onChange?.(date);
      }

      return (
        <TimePicker
          {...props}
          {...input}
          invalid={typeof props.invalid === 'boolean' ? props.invalid : Boolean(error)}
          error={props.error ? props.error : error}
          onChange={handleChange}
        />
      );
    }}
  </Field>
);
